export enum CalculatorType {
	Mortgage = "mortgage",
	Refinancing = "refinancing",
	AmericanMortgage = "americanMortgage",
	ConsumerLoan = "consumerLoan",
	PensionAnnuity = "pensionAnnuity",
	ChildrenSavings = "childrenSavings",
	GoalAchieve = "goalAchieve",
	TravelInsurance = "travelInsurance",
	CarMotoInsurance = "carMotoInsurance",
	PropertyInsurance = "propertyInsurance",
}
